function base(str) {
  return str.replace(/([^0-9x/])[0-9x]+$/, "$1");
}

function index(str) {
  let match = str.match(/[^0-9x /]([0-9x]+)/);

  if (match) {
    if (match[1] === "x") return match[1]
    return Number(match[1]);
  } else {
    return 1;
  }
}

function indexString(str) {
  let i = index(str);
  if (i == 1) return "";
  else return "" + i;
}


function syllabic(str, useAccent) {
  return str.split(/(\sx\s|[ .-])/).map(x=>syllabic_sub(x,useAccent)).join("")

}

function syllabic_sub(str, useAccent) {
  let idx = index(str);

  if (useAccent && idx <= 3) {
    let accent = function(c) {
      return {
        a: ["a", "á", "à"],
        i: ["i", "í", "ì"],
        u: ["u", "ú", "ù"],
        e: ["e", "é", "è"],
        A: ["A", "Á", "À"],
        I: ["I", "Í", "Ì"],
        U: ["U", "Ú", "Ù"],
        E: ["E", "É", "È"]
      }[c][idx - 1];
    };
    return base(str).replace(/[aiue]/, accent);
  } else {
    var result = "";
    let istr = indexString(str);

    for (let i = 0; i < istr.length; i++) {
      if (istr === "x") {
        result = result + "ₓ";
      } else {
        const c = parseInt(istr.charAt(i));
        if (isNaN(c)) {
          result += istr.charAt(i);
        } else {
          result = result + String.fromCodePoint(0x2080 + c);
        }
      }
    }
    return base(str) + result;
  }
}

export default syllabic;
